import type {PropsWithChildren} from 'react';

interface INoItemProps extends PropsWithChildren {
  title?: string;
  description?: string;
}

const NoItem = ({children, title = 'No records', description = 'Get started by creating some records'}: INoItemProps) => {
  return (
    <div className="flex justify-center items-center rounded-lg bg-white dark:bg-darkBg border border-slate-200 dark:border-slate-500 text-center shadow-xs p-5">
      <div className="max-w-sm flex flex-col gap-2">
        <h1 className="text-xl lg:text-2xl dark:text-white">{title}</h1>
        <p className="text-slate-700 dark:text-darkText">{description}</p>
        {children}
      </div>
    </div>
  );
};

export default NoItem;
